/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CloudProviderEnum = 'AWS' | 'GCP' | 'VMWARE' | 'ON_PREM' | 'MOCK';

export const CloudProviderEnum = {

    AWS: 'AWS' as CloudProviderEnum,

    GCP: 'GCP' as CloudProviderEnum,

    VMWARE: 'VMWARE' as CloudProviderEnum,

    ON_PREM: 'ON_PREM' as CloudProviderEnum,

    MOCK: 'MOCK' as CloudProviderEnum
};

